import $ from 'jquery';

/**
 * Daterangepicker is registered synchronously via vendor/daterangepicker-load.js in index.js.
 */
export default function ensureDateRangePicker() {
  if ($.fn.daterangepicker) {
    return Promise.resolve();
  }

  return Promise.reject(
    new Error('bootstrap-daterangepicker did not register on jQuery'),
  );
}
